export class RouteStrategy {
  constructor(matcher, routeGenerator, order) {
    this.matches = matcher;
    this.getRoute = routeGenerator;
    this.order = order;
  }
}
